import * as React from 'react';
import { PassengersToolbarProps } from './types';
import PassengersToolbarWithoutForm from './components/PassengersToolbarWithoutForm/PassengersToolbarWithoutForm';
import PassengersToolbarWithForm from './components/PassengersToolbarWithForm/PassengersToolbarWithForm';

const PassengersToolbar: React.FC<PassengersToolbarProps> = props => {
	const { hasForm } = props;

	if (!hasForm) {
		return <PassengersToolbarWithoutForm {...props} />;
	}

	return <PassengersToolbarWithForm {...props} />;
};

export default PassengersToolbar;
